import { NgModule, Optional, SkipSelf } from "@angular/core";
import { CommonModule } from "@angular/common";
import { Routes, RouterModule } from "@angular/router";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { MaterialComponentsModule } from "./../material-components.module";

// Core directives
import { HasPermissionDirective } from "./directives/has-permission.directive";

// Core services
import { CommonService } from "./services/common.service";
import { CommonHttpService } from "./services/common-http.service";
import { DataStoreService } from "./services/data-store.service";
import { JwtService } from "./services/jwt.service";
import { PermissionsService } from "./services/permissions.service";
import { AzureService } from "./services/azure.service";
import { RoleCheckerService } from "./services/role-checker.service";
import { AppRoutingAccess, HasTokenResolver } from "./services/resolver.service";

// Guards
import { SuperAdminGuard } from "./guards/super-admin.guard";
import { CompanyAdminGuard } from "./guards/company-admin.guard";
import { PermissionsGuard } from "./guards/permissions.guard";

// Interceptors
import { ErrorHandlerInterceptor } from "./interceptors/error-handler.interceptor";
import { HttpTokenInterceptor } from "./interceptors/http-token.interceptor";

// Core components
import { PageNotFoundComponent } from "./page-not-found/page-not-found.component";

@NgModule({
  imports: [
    CommonModule,
    MaterialComponentsModule,
    RouterModule,
    HttpClientModule,
  ],
  declarations: [
    PageNotFoundComponent,
    HasPermissionDirective,
  ],
  exports: [HttpClientModule, PageNotFoundComponent, HasPermissionDirective],
  providers: [
    // Core services
    CommonService,
    CommonHttpService,
    DataStoreService,
    JwtService,
    PermissionsService,
    AzureService,
    RoleCheckerService,
    AppRoutingAccess,
    HasTokenResolver,
    // Guards
    SuperAdminGuard,
    CompanyAdminGuard,
    PermissionsGuard,
    // Interceptors
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorHandlerInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpTokenInterceptor,
      multi: true,
    },
  ],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the AppModule only'
      );
    }
  }
}
